var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541,
    height: 469,
    viewBox: "0 0 541 469",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.17 469H87.5457C73.6657 456.178 60.9341 441.689 49.6486 425.587C-35.7615 303.721 -6.00633 135.549 116.109 49.9643C238.224 -35.6201 406.456 -6.20785 491.866 115.658C570.379 227.684 551.575 378.838 453.17 469Z",
    fill: "url(#paint0_linear_82_362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_362",
    x1: 496.5,
    y1: 113,
    x2: 48,
    y2: 440.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.92d5dc3224a17b593145842a9b8402d7.svg";
export { ForwardRef as ReactComponent };